export default {
  methods: {
    connect() {
      let url = 'tencent://message/?uin=2230259928&Site=&Menu=yes'
      window.open(url)
    },
  }
}



// WEBPACK FOOTER //
// ./src/mixin/connectMixin.js